module.exports = __webpack_public_path__ + "img/fair.4437fbc9.svg";